import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useContext } from 'react';
export function useAdsType() {
    const { adsEnabled , isLoggedIn  } = useContext(SessionContext);
    if (!adsEnabled) {
        return 'off';
    }
    if (isLoggedIn) {
        return 'user';
    }
    return 'anon';
}
